import styled from "styled-components";

export const Container = styled.section`
  margin-top: 12rem;
  .skills-divs {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 1rem;
    padding: 10px 0;
  }

  .skills-div {
    border-radius: 10px;
    border: 1px solid #363535;
    padding: 10px;
    height: 100% !important;
    transition: 0.25s;
    &:hover {
      transform: translateY(-5px);
      background-color: var(--pink);
      strong {
        color: #212121;
        border-bottom: 1px solid #212121;
      }
    }
    .skill-link {
      color: white;
      text-decoration: underline;
    }
  }

  strong {
    color: var(--pink);
    display: block;
    width: fit-content;
    border-bottom: 1px solid var(--pink);
    margin-bottom: 3px;
  }

  .hard-skills {
    margin-top: 1.6rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 1.8rem;
  }
  .hability {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 3.4rem;
    }
  }

  h2 {
    display: inline-block;
    margin-bottom: 2rem;
    border-bottom: 0.2rem solid var(--blue);
  }

  h3 {
    margin-top: 2rem;
    color: var(--pink);
  }

  p {
    font-size: 1.8rem;
    letter-spacing: 0.1rem;
    font-weight: 500;
  }

  @media only screen and (max-width: 480px) {
    .about-image {
      max-width: 100%;
      margin-top: 4rem;
    }
    .skills-div-container {
      display: grid;
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 960px) {
    display: block;
    text-align: center;

    .about-image {
      display: flex;
    }
    .hard-skills {
      justify-content: center;
    }
  }
`;
